import { Row } from '@design-system/components/grid/grid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen } from '@fortawesome/pro-regular-svg-icons';
import MediaUpload from '@client/new/components/MediaUpload';
import { FormLabelSuperTooltip } from './FormLabelSuperTooltip';
import { ProfileVM } from '../../view-model/Profile.viewModel';
import { ProfileFormValues } from '../../view-model/Profile.schema';
import * as styles from './MediaSection.css';

type MediaSectionProps = {
  vm: ProfileVM;
};

export const MediaSection = ({ vm }: MediaSectionProps) => {
  const { form } = vm;
  const mediaBanner = form.watch('mediaBanner');
  const mediaWelcome = form.watch('mediaWelcome');

  return (
    <Row gap="xl" className={styles.mediaRow}>
      <div>
        <FormLabelSuperTooltip templateId="profile-banner">
          Profile banner
        </FormLabelSuperTooltip>
        <div className={styles.uploadWrapper}>
          <MediaUpload
            id="mobile-banner"
            creatorId={vm.profile.id}
            accept={['image/png', 'image/jpeg']}
            crop
            aspectRatio={[1125, 420]}
            className={styles.bannerCard}
            value={mediaBanner || null}
            onChange={(metadata) => {
              form.setValue(
                'mediaBanner',
                metadata as ProfileFormValues['mediaBanner'],
                { shouldDirty: true },
              );
            }}
          >
            <div className={styles.mediaInfoText}>
              <span className={styles.mediaInfoTitle}>
                Shown at the top of your profile
              </span>
              <span className={styles.mediaInfoSubtitle}>1125 x 420px</span>
            </div>
          </MediaUpload>
          {!mediaBanner && (
            <div className={styles.editBadge}>
              <FontAwesomeIcon icon={faPen} />
            </div>
          )}
        </div>
      </div>

      <div>
        <FormLabelSuperTooltip templateId="intro-video">
          Intro video
        </FormLabelSuperTooltip>
        <div className={styles.uploadWrapper}>
          <MediaUpload
            id="welcome-video"
            creatorId={vm.profile.id}
            accept={['video/mp4']}
            showTimeLeft
            aspectRatio={[9, 16]}
            className={styles.videoCard}
            value={mediaWelcome || null}
            onChange={(metadata) => {
              form.setValue(
                'mediaWelcome',
                metadata as ProfileFormValues['mediaWelcome'],
                { shouldDirty: true },
              );
            }}
          >
            <div className={styles.mediaInfoText}>
              <span className={styles.mediaInfoTitle}>
                Short intro up to 30 s
              </span>
              <span className={styles.mediaInfoSubtitle}>9:16 (portrait)</span>
            </div>
          </MediaUpload>
          {!mediaWelcome && (
            <div className={styles.editBadge}>
              <FontAwesomeIcon icon={faPen} />
            </div>
          )}
        </div>
      </div>
    </Row>
  );
};
